<template>
  <div class="alert">
    <p>{{ this.msg }}</p>
    <div>
      <base-button
        :text="'Fechar'"
        v-if="type == 'alert'"
        @click="onConfirm(true)"
      />
      <div v-if="type == 'confirm'" class="d-flex">
        <base-button @click="onConfirm(true)" class="yes">Sim</base-button>
        <base-button @click="onConfirm(false)" design="two" class="no"
          >Não</base-button
        >
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import Vue from 'vue';

// UI

import BaseButton from '@/components/Button';

export default Vue.extend({
  props: {
    msg: { default: '' },
    type: { default: 'alert' },
    cb: null,
  },
  methods: {
    async onConfirm(confirmation = false) {
      if (this.msg.indexOf('Cupom criado com sucesso!') > -1) {
        this.$router.push('sales');

        setTimeout(() => {
          this.$router.push('cupons');
        }, 1);
      }
      await this.$emit('closeAlert');
      if (typeof this.cb === 'function') return this.cb(confirmation);
    },
  },
  components: {
    BaseButton,
  },
});
</script>

<style scoped>
.alert {
  margin-top: 5px;
}
.alert > p {
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  color: #aaaaabcc;
}

.alert > div {
  margin-top: 30px;
  display: flex;
  justify-content: center;
}

.alert .yes {
  margin-right: 15px;
}

.alert .yes,
.alert .no {
  width: 110px;
}
</style>
